import React from 'react';
import styled from 'styled-components';
import { UserFriends } from '@styled-icons/fa-solid/UserFriends';

const HamburgerContainer = styled.div`
  position: absolute;
  top: 0.75rem;
  left: 1rem;
  z-index: 1000;
`;

const HamburgerButton = styled.button`
  background: var(--clr-bg-secondary, #2a2a2a);
  border: 1px solid var(--clr-border, #444);
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    background: var(--clr-bg-hover, #3a3a3a);
    border-color: var(--clr-primary, #007bff);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const HamburgerIcon = styled(UserFriends)`
  width: 18px;
  height: 18px;
  color: var(--clr-text, #ffffff);
`;

const UnreadBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.count > 0 ? 1 : 0};
  transform: scale(${props => props.count > 0 ? 1 : 0});
  transition: all 0.2s ease;
`;

function DMHamburgerButton({ onClick, unreadCount = 0 }) {
  return (
    <HamburgerContainer>
      <HamburgerButton onClick={onClick}>
        <HamburgerIcon />
        <UnreadBadge count={unreadCount}>
          {unreadCount > 99 ? '99+' : unreadCount}
        </UnreadBadge>
      </HamburgerButton>
    </HamburgerContainer>
  );
}

export default DMHamburgerButton;